import axios from '../utils/interceptor';
import updateTemplateWithAccessibilitySettings from '../../authentication/utils/updateTemplateWithAccessibilitySettings';
import { getCookie } from '../utils/cookies';
import { AccessibilityThemes, AccessibilityThemesProps, apiUrls, SessionStore } from '../../constants';
import { useEffect } from 'react';
import { useAppSelector } from '../../redux-store/hook';
import { templateProvider } from '../../redux-store/providers/templateProvider';

export const useAccessibility = (): void => {
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const isBasicFlow = getCookie('BasicFlow') === '1';
  const template = useAppSelector((state) => state.template);
  const { setTemplate } = templateProvider();
  const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
  const parsedWorkflowSession = workflowSession && JSON.parse(workflowSession);
  const colorContrast = parsedWorkflowSession?.colorContrast;
  const defaultTemplate = useAppSelector((state) => state.defaultTemplate);

  /** If user didnt select any colour-contrast from accessbility dropdown
   * then after login the previously saved color-contrast will be applied on template,
   * & if user changed the colour contrast before login,
   * then this color contrast wil be carried over after login & will be saved to BE also.
   */
  useEffect(() => {
    if (tcPlusFlow && isBasicFlow && colorContrast) {
      const selectedAccessibilityTheme = sessionStorage.getItem(SessionStore.selectedAccessibilityTheme) || '0';
      if (+selectedAccessibilityTheme === 0 && colorContrast !== 1) {
        const selectedAccessibility = AccessibilityThemes.filter(
          (item: AccessibilityThemesProps) => item.id === colorContrast,
        )[0];
        setTemplate(updateTemplateWithAccessibilitySettings(template, selectedAccessibility, defaultTemplate));
      } else if (+selectedAccessibilityTheme !== 0 && +selectedAccessibilityTheme !== colorContrast) {
        axios.put(apiUrls.UPDATE_WORKFLOW_METADATA, { colorContrast: +selectedAccessibilityTheme });
        parsedWorkflowSession.colorContrast = +selectedAccessibilityTheme;
        sessionStorage.setItem(SessionStore.workflowSession, JSON.stringify(parsedWorkflowSession));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorContrast]);
};
